module.exports = __webpack_public_path__ + "img/wild_comming.c51b5d30.png";